module.exports = __webpack_public_path__ + "static/map-fd7f30597ca7b5574685e9a028f0e64b.png";